import { reduxForm } from 'redux-form'
import at from 'lodash/at'

import { loadAreasByLocation } from '../../actions/areas'
import { fetchQAWorkOrder } from '../../actions/qa-work-orders'
import { createQAServicing } from '../../actions/qa-servicings'

import { goBack } from 'react-router-redux'

import QAServicingMultiForm from '../../components/qa-servicings/qa-servicing-multi-form'

const fields = [
  'areaIds'
]

function mapStateToProps (state, ownProps) {
  const qaWorkOrder = state.qaWorkOrders[ownProps.params.qaWorkOrderId]

  if (!qaWorkOrder) return { loading: true }

  const location = state.locations[qaWorkOrder.location]
  const areas = at(state.areas, location.areas || [])

  return {
    modalTitle: 'Add an Area',
    locations: {},
    areas: areas.map(area => ({ value: area.id, label: area.name }))
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const qaWorkOrderID = ownProps.params.qaWorkOrderId

  dispatch(fetchQAWorkOrder(qaWorkOrderID))
    .then(action => {
      const locationId = action.payload.entities.qaWorkOrders[action.payload.result].locationId
      dispatch(loadAreasByLocation(locationId))
    })

  return {
    onSubmit (data) {
      const promises = (data.areaIds || []).map(areaId =>
        dispatch(createQAServicing(qaWorkOrderID, { areaId }))
      )

      Promise.all(promises).then(() => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'createQAServicing'
  },
  mapStateToProps,
  mapDispatchToProps
)(QAServicingMultiForm)



// WEBPACK FOOTER //
// ./src/containers/qa-servicings/qa-servicing-multi-create-container.js